import {
  AppType,
  FrequentlyAskedQuestions,
  IncludedCommonFormFields,
  Integration,
  OrderFormField,
  Restrictions,
  TrialConfiguration,
} from '@galaxy/marketplace-apps/v1';
import { BillingFrequency, Currency } from '../types';
import { CaseTransform } from '../utils/case-transform';
import { formatDisplayPrice } from '../utils/pipe-utils';

const lmiCategoriesMap: { [type: string]: string } = {
  advertising: 'Advertising',
  content_and_experience: 'Content and Experience',
  reputation: 'Reputation',
  seo: 'SEO',
  social: 'Social',
  website: 'Website',
  listings: 'Listings',
};

export interface EndUserMarketing {
  description: string;
  keySellingPoints: string[];
  faqs: FrequentlyAskedQuestions[];
  files: string[];
}

export class MarketplaceApp {
  appId: string;
  name: string;
  type: AppType;
  vendor: string;
  price: number;
  setupFee: number;
  suggestedRetailPrice: number; // price is in cents
  allowPriceNegotiation: boolean;
  currency: Currency;
  billingFrequency: BillingFrequency;
  tagline?: string;
  lmiCategories?: any[];
  icon?: string;
  headerImage?: string;
  screenshot?: string[];
  orderForm?: OrderFormField[];
  commonForm?: IncludedCommonFormFields;
  integration?: Integration;

  // Reseller marketing
  description?: string;
  activationMessage?: string;
  _keySellingPoints?: string[];
  faqs?: any[];
  pdfUpload?: string[];
  restrictions?: Restrictions;
  allowMultipleActivations?: boolean;
  usesOrderForm: boolean;
  usesActivationSpecificEntryUrl: boolean;
  activationRequiresApproval?: boolean;
  billingId: string;
  usesEditions: boolean;
  editionIds: string[];
  suspended: Date;
  usesCustomPricing: boolean;

  endUserMarketing: EndUserMarketing;
  trialConfiguration: TrialConfiguration;

  /* tslint:disable:no-string-literal */
  constructor(data: any) {
    data = CaseTransform.objectPropertiesSnakeToCamel(data);
    Object.assign(this, data, {
      currency: data['currency'] ? data['currency'].toUpperCase() : 'USD',
      billingFrequency: data['billingFrequency'] ? data['billingFrequency'].toLowerCase() : 'monthly',
    });
  }

  get formattedPrice(): string {
    return formatDisplayPrice(this.price, this.currency, this.billingFrequency);
  }

  get lmiCategoriesText(): string[] {
    return this.lmiCategories.map((category) => lmiCategoriesMap[category]);
  }

  set keySellingPoints(keySellingPoints: string[]) {
    this._keySellingPoints = keySellingPoints;
  }

  get keySellingPoints(): string[] {
    return this._keySellingPoints.filter((sellingPoint) => sellingPoint && sellingPoint !== '');
  }
}
